import React from "react";
import { Box } from "@mui/material";
import HeroEngine1 from "../components/HeroEngine1";
import HeroEngine2 from "../components/HeroEngine2";
import HeroEngine3 from "../components/HeroChannel3";
import HeroEngine4 from "../components/HeroEngine4";
import Footer from "../components/Footer";

function ChannelManagerPage() {
  return (
    <Box
      sx={{
        height: "100vh",
        overflowY: "scroll",
        scrollSnapType: "y mandatory",
        scrollBehavior: "smooth",
      }}
    >
      {/* Sección 1 - HeroChannel1 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: "100vh",
          minHeight: "100vh",
          overflow: "hidden", // 👈 Evita que se solape
          position: "relative",
          zIndex: 1, // 👈 Asegura la superposición correcta
        }}
      >
        <HeroEngine1 />
      </Box>
      {/* Sección 3 - HeroChannel3 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: {
            xs: "auto",
            sm: "auto",
            md: "100vh",
            lg: "100vh",
            xl: "100vh",
          },
          minHeight: "100vh",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
          mt: 0, // 👈 Evita saltos
        }}
      >
        <HeroEngine4 />
      </Box>
      {/* Sección 2 - HeroChannel2 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: {
            xs: "auto",
            sm: "auto",
            md: "100vh",
            lg: "100vh",
            xl: "100vh",
          },
          minHeight: "100vh",
          position: "relative",
          zIndex: 1,
          mt: 0, // 👈 Evita saltos
        }}
      >
        <HeroEngine2 />
      </Box>

      {/* Sección 3 - HeroChannel3 */}
      <Box
        sx={{
          scrollSnapAlign: "start",
          height: {
            xs: "auto",
            sm: "auto",
            md: "100vh",
            lg: "100vh",
            xl: "100vh",
          },
          minHeight: "100vh",
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
          mt: 0, // 👈 Evita saltos
        }}
      >
        <HeroEngine3 />
      </Box>

      <Box
        sx={{
          scrollSnapAlign: "start",
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
}

export default ChannelManagerPage;
